import React from 'react'
import { connect } from 'react-redux'
import ButtonAddInfo from '../../components/controls/ButtonAddInfo'
import CustomDatePicker from '../../components/controls/CustomDatePicker'
import ExpandableListElement from '../../components/controls/ExpandableListElement'
import Szambelan from '../../components/Szambelan'
import { controlHasError } from '../../lib/errorHandler'
import { dateFromCalendar, formatDate } from '../../lib/formatDateHandler'
import MainStyle from '../../styles/MainStyle'
import WykazJednostekSkonsolidowaneStyle from '../../styles/WykazJednostekSkonsolidowaneStyle'
import logo from '../../assets/images/szambelan_okresow.svg'
import SiedzibaR2 from '../../components/daneIdentyfikacyjne/SiedzibaR2'

function WykazJednostekWylaczonych({
  onSetSectionDataArray,
  validityErrors,
  data,
  sIndex,
  dataOd,
  dataDo,
}) {
  function struktura() {
    return {
      DataOd: dataOd,
      DataDo: dataDo,
      Nazwa: '',
      Adres: {
        SiedzibaZagraniczna: false,
        Wojewodztwo: '',
        Powiat: '',
        Gmina: '',
        Ulica: '',
        NrDomu: '',
        NrLokalu: '',
        Miejscowosc: '',
        KodPocztowy: '',
        KodKraju: '',
      },
      DataOdJednostki: '',
      DataDoJednostki: '',
    }
  }
  return (
    <MainStyle className={data.Pozycje.length > 0 ? '' : 'hide-on-print'}>
      <WykazJednostekSkonsolidowaneStyle>
        <div className='site-header high-emphasis-subtitle-1'>
          <span>
            JEDNOSTKI POWIĄZANE, W KTÓRYCH LATA OBROTOWE LUB OKRESY
            SPRAWOZDAWCZE
            <br /> RÓŻNIĄ SIĘ OD OKRESU OBJĘTEGO SPRAWOZDANIEM SKONSOLIDOWANYM
          </span>
          <ButtonAddInfo
            label='DODAJ JEDNOSTKĘ'
            structure={struktura()}
            sIndex={sIndex}
          />
        </div>
        {data.Pozycje.length > 0 ? (
          <div className='container'>
            <div className='list-header caption'>
              <p>NAZWA I SIEDZIBA JEDNOSTKI POWIĄZANEJ</p>
            </div>
            {data.Pozycje.map((data, index) => {
              let adresDraft = { ...(data.Adres || {}) }
              const setAdresField = (name, value) => {
                adresDraft = { ...adresDraft, [name]: value }
                onSetSectionDataArray(adresDraft, index, 'Adres')
              }
              return (
                <ExpandableListElement
                  expandationDisabled={true}
                  placeholder='Nazwa i siedziba jednostki powiązanej'
                  sectionIndex={sIndex}
                  nazwaPozycji={data.Nazwa}
                  key={index}
                  index={index}
                  hasError={(name, value) =>
                    controlHasError(validityErrors, name, value, true)
                  }
                >
                  <div className="siedzibaR2Wrapper">
                    <SiedzibaR2
                      key={index}
                      errors={validityErrors.filter(
                        (value) => value.TypSekcji === data.TypSekcji,
                      )}
                      data={data.Adres || {}}
                      onSetSectionData={setAdresField}
                    />
                  </div>
                  <div className='header dates-header'>
                    <p>DATA OD</p>
                    <p>DATA DO</p>
                  </div>
                  <div className='subsection'>
                    <div className='dates'>
                      <CustomDatePicker
                        name='DataOdJednostki'
                        error={controlHasError(
                          validityErrors,
                          'DataOdJednostki',
                          data.DataOdJednostki,
                        )}
                        label='Data od'
                        value={formatDate(data.DataOdJednostki)}
                        onChange={(e) =>
                          onSetSectionDataArray(
                            dateFromCalendar(e),
                            index,
                            'DataOdJednostki',
                          )
                        }
                      />
                      <p className='separator'>-</p>
                      <CustomDatePicker
                        name='DataDoJednostki'
                        error={controlHasError(
                          validityErrors,
                          'DataDoJednostki',
                        )}
                        label='Data do'
                        value={formatDate(data.DataDoJednostki)}
                        onChange={(e) =>
                          onSetSectionDataArray(
                            dateFromCalendar(e),
                            index,
                            'DataDoJednostki',
                          )
                        }
                      />
                    </div>
                  </div>
                </ExpandableListElement>
              )
            })}
          </div>
        ) : (
          <Szambelan
            logo={logo}
            text={
              <>
                Brak informacji o różnicach
                <br /> okresów sprawozdawczych
                <br /> w jednostkach powiązanych
              </>
            }
          />
        )}
      </WykazJednostekSkonsolidowaneStyle>
    </MainStyle>
  )
}

const mapStateToProps = (state) => ({
  dataOd: state.sprawozdanie.dateFrom,
  dataDo: state.sprawozdanie.dateTo,
})

export default connect(mapStateToProps)(WykazJednostekWylaczonych)
